module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"nav":{"view":"Обзор","config":"Изменить конфигурацию","backup":"Бэкапы","history":"История","access":"Доступ","ip":"IP-адреса"}}}')
  delete Component.options._Ctor
}
